var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.11107 14.5001V8.94453M10.5555 14.5001V5.61119M15 14.5001V12.2779M17.2222 1.16675H3.88885C3.29948 1.16675 2.73425 1.40087 2.3175 1.81762C1.90075 2.23437 1.66663 2.7996 1.66663 3.38897V16.7223C1.66663 17.3117 1.90075 17.8769 2.3175 18.2937C2.73425 18.7104 3.29948 18.9445 3.88885 18.9445H17.2222C17.8116 18.9445 18.3768 18.7104 18.7935 18.2937C19.2103 17.8769 19.4444 17.3117 19.4444 16.7223V3.38897C19.4444 2.7996 19.2103 2.23437 18.7935 1.81762C18.3768 1.40087 17.8116 1.16675 17.2222 1.16675Z",
    stroke: "white",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/Insight.2150e50579c6238c238add4f32690c5b.svg";
export { ForwardRef as ReactComponent };